module.exports = __webpack_public_path__ + "static/media/a89.3598c587.jpg";